<template>
    <b-card no-body :bg-variant="style.bg" :border-variant="style.border" v-if="show">
        <div class="card-header">
            <h4>{{ title }}</h4>
        </div>
        <div class="card-body" v-if="instruction.file">
            <div>
                <h5 class="text-capitalize mb-75">Document</h5>
                <p class="card-text">{{ instruction.file.name }}</p>
            </div>
            <div class="mt-1">
                <h5 class="text-capitalize mb-75">Description</h5>
                <p class="card-text">{{ instruction.description }}</p>
            </div>
        </div>
        <div class="card-body" v-else>
            <b-alert
                :variant="style.alert"
                show
            >
                <div class="alert-body">
                    {{ emptyText }}
                </div>
            </b-alert>
        </div>
    </b-card>
</template>

<script>
import {
    BCard, BRow, BCol, BFormCheckbox, BFormTextarea, BAlert
} from 'bootstrap-vue'

export default {
    components: {
        BCard, BRow, BCol, BFormCheckbox, BFormTextarea, BAlert,
    },
    props: {
        title: {
            required: true
        },
        state: {
            default: 'default'
        },
        show: {
            type: Boolean,
            default: true
        },
        instruction: {
            type: Object,
            required: true
        },
        emptyText: {
            type: String,
            default() {
                return 'There is no ' + this.title;
            }
        }
    },
    methods: {
        onChange(value) {
            this.$emit('input', value, this.instruction);
        }
    },
    computed: {
        style() {
            return this.$store.state.request.received.replyVariant[this.state];
        }
    }
}
</script>
